import type { SVGProps } from "react";

export default function ExpandIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.4974 12.5L1.66406 18.3333M1.66406 18.3333H6.54501M1.66406 18.3333V13.4524"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.50033L18.3333 1.66699M18.3333 1.66699H13.4524M18.3333 1.66699V6.54794"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
